import script from "./LeftSideBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftSideBar.vue?vue&type=script&setup=true&lang=ts"

import "./LeftSideBar.vue?vue&type=style&index=0&id=f47a28e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f47a28e0"]])

export default __exports__